// removed by extract-text-webpack-plugin
module.exports = {"sortBy":"SortBy-sortBy-5fdf2858","filterMode":"SortBy-filterMode-a7ee4e9a","icon":"SortBy-icon-6aedd7b1","message":"SortBy-message-631b1ef9"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/SortBy.scss
// module id = 823
// module chunks = 0